"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _merchant = require("@/api/merchant");
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      selectedMerchant: '',
      merchantList: []
    };
  },
  props: {
    merchantId: {
      type: Number,
      required: true
    }
  },
  methods: {
    getMerchantList: function () {
      var _getMerchantList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getDistributionMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  this.merchantList = res.data;
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    handleMerchantChange: function handleMerchantChange() {
      this.$emit('merchantSelected', this.selectedMerchant);
    },
    reset: function reset() {
      this.selectedMerchant = '';
      console.log('selectedMerchant', this.selectedMerchant);
      this.$emit('merchantSelected', this.selectedMerchant);
    }
  },
  mounted: function mounted() {
    // 如果是供应商则请求
    if (this.merchantId == 0) {
      this.getMerchantList();
    }
  }
};
exports.default = _default;